// extracted by mini-css-extract-plugin
export default {"main-grid":"VupUkIpvoNFWYwflKeAr","long":"e5ADJl5wUgY6AHoY3e5X","main-content":"YGyrUg6TW3_YrxIy6RvM","form":"u4esB3oQz_8vhfN0AnKY","button":"ZE0iZmv9JBa7EcBGaWVo"};